/**
 * Pages that render a customer's chatbot rather than chat.co itself: the
 * embedded widget (/embed/<botId>, loaded in an iframe on the customer's site)
 * and the hosted chat UI (/c/<pk_live_…>).
 *
 * Their visitors belong to the customer, so chat.co's own cookie banner and
 * Google tag (Analytics + Ads) must not load on them.
 */
export const CUSTOMER_CHAT_PATH_PATTERN = /^\/(embed|c)(\/|$)/;

/**
 * Accepts either the route pattern (`router.pathname`, e.g. `/embed/[id]`) or
 * a concrete path.
 */
export const isCustomerChatSurface = (pathname: string | null | undefined): boolean =>
  CUSTOMER_CHAT_PATH_PATTERN.test((pathname || '').split(/[?#]/)[0]);

/** Attribute set on <html> before first paint on customer chat URLs (see _document). */
export const CUSTOMER_CHAT_HTML_ATTRIBUTE = 'data-customer-chat';

/**
 * Inline, render-blocking script for _document's <head>: marks customer chat
 * URLs before the body paints, so CSS can hide chat.co's own chrome there
 * even if the page's JavaScript is slow or never runs.
 */
export const customerChatMarkerScript = `if(${CUSTOMER_CHAT_PATH_PATTERN.toString()}.test(window.location.pathname))document.documentElement.setAttribute('${CUSTOMER_CHAT_HTML_ATTRIBUTE}','');`;

/**
 * Pairs with the marker: `.customer-chat-hide` is hidden on customer chat
 * URLs, `.customer-chat-only` everywhere else.
 */
export const customerChatMarkerStyle = `html[${CUSTOMER_CHAT_HTML_ATTRIBUTE}] .customer-chat-hide{display:none!important}html:not([${CUSTOMER_CHAT_HTML_ATTRIBUTE}]) .customer-chat-only{display:none!important}`;
